import { ScheduledMessage } from 'models/automation/ScheduledMessages';
import TriggerStateIcon from 'pages/automations/common/TriggerStateIcon';

interface StateCellProps {
  getValue: () => ScheduledMessage['state'];
}

const StateCell = ({ getValue }: StateCellProps) => {
  const state = getValue();

  return <TriggerStateIcon state={state} />;
};

export default StateCell;
